import { SignatureRequest } from "../interfaces";

interface Props {
  signatureRequest: SignatureRequest;
}

function SignatureRequestLinkPreview(props: Props) {
  const { signatureRequest } = props;

  return (
    <div className="flex items-center justify-center bg-white m-auto p-8 rounded shadow">
      <div>{signatureRequest.publicTokenUrl}</div>
    </div>
  );
}

export default SignatureRequestLinkPreview;
